import { FaCircle, FaUsers, FaBookOpen, FaRegEnvelope, FaTags, FaShareAlt, FaBars, FaUserPlus, FaUser, FaCopy, FaBuilding } from 'react-icons/fa'
import { useNavigate } from 'react-router-dom'
import { Grid, GridItem } from '@chakra-ui/react'
import { SettingsCard } from '../../../../components/SettingsCard'
import './grid-configuracao.scss'
import { useState, useEffect } from 'react'

const GridSettings = () => {
  const navigate = useNavigate()
  const [submenus, setSubmenus] = useState<any[]>([])

  useEffect(() => {
    const permissaoAcessos = localStorage.getItem('permissaoAcesso');
    if (permissaoAcessos) {
      const parsedPermissaoAcesso = JSON.parse(permissaoAcessos);
  
      const configuracaoSubmenus = parsedPermissaoAcesso
        .filter((item: any) => item.menuDTO.fkCodMenu === 20000)
        .map((item: any) => {
          let path = `/cms/configuracao/${item.menuDTO.dscMenu.toLowerCase().replace(/\s+/g, '-')}`;
          let icon;
  
          switch(item.menuDTO.codMenu) {
            case 20070:
              icon = FaUser;
              path = '/cms/configuracao/gerenciar-usuario';
              break;
            case 20080:
              icon = FaUsers;
              path = '/cms/configuracao/gerenciar-perfil-usuario';
              break;
            case 20020:
              icon = FaRegEnvelope;
              path = '/cms/configuracao/servico-comunicacao';
              break;
            case 20030:
              icon = FaTags;
              path = '/cms/configuracao/gerenciar-categoria';
              break;
            case 20040:
              icon = FaShareAlt;
              path = '/cms/configuracao/aplicativo';
              break;
            case 20050:
              icon = FaBars;
              path = '/cms/configuracao/gerenciar-menu';
              break;
            case 20060:
              icon = FaUserPlus;
              path = '/cms/configuracao/midias-sociais';
              break;
            case 20300:
              icon = FaBuilding;
              path = '/cms/configuracao/gerenciar-secretarias';
              break;
            case 20090:
              icon = FaCopy;
              path = '/cms/configuracao/gerenciar-tipo-midia';
              break;
            default:
              icon = FaCircle;
              path = `/cms/configuracao/${item.menuDTO.dscMenu.toLowerCase().replace(/\s+/g, '-')}`;
          }
  
          return {
            cardTitle: item.menuDTO.dscMenu,
            path: path,
            icon: icon
          };
        });
  
      setSubmenus(configuracaoSubmenus);
    }
  }, []);
  

  return (
    <div className='main-container-grid'>
        {submenus.map((submenu, index) => (
          <GridItem key={index}>
            <SettingsCard
              buttonText="Acessar"
              onClick={() => navigate(submenu.path)}
              icon={submenu.icon}
              cardTitle={submenu.cardTitle}
            />
          </GridItem>
        ))}
    </div>
  )
}

export default GridSettings
